import ApiService from "./apiService";
import { webapiPost } from "../webapis/core";
import { BEConfig } from "../config/env";

type ProductPurchaseItem = {
  id: number;
  price: number;
  quantity: number;
  queryID?: string;
};

class AlgoliaInsightsService extends ApiService {
  async trackProductClick({
    position,
    productId,
    queryID,
    algoliaIndex,
    origin
  }: AlgoliaInsightsFullProductEventType): Promise<any> {
    const apiURL = `${this.getBaseUrl()}/product-click`;

    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      {
        position,
        productId: productId.toString(),
        queryID,
        algoliaIndex,
        origin
      },
      this.getVisitorId(),
      this.getLanguage()
    ).request;

    return response.data;
  }

  async trackProductPurchase({
    products
  }: {
    products: ProductPurchaseItem[];
  }) {
    const apiURL = `${this.getBaseUrl()}/product-purchase`;

    const response = await webapiPost(
      this.getAccessToken(),
      apiURL,
      {
        products
      },
      this.getVisitorId(),
      this.getLanguage()
    ).request;

    return response.data;
  }

  getBaseUrl() {
    const { baseURL, protocol, port, versionInfo } = BEConfig.productsApi;

    const url = `${protocol}${baseURL}${port}${versionInfo}algolia-events`;

    return url;
  }
}

type AlgoliaInsightsFullProductEventType = {
  position: number;
  productId: string | number;
  queryID?: string;
  algoliaIndex?: string;
  origin?: string;
};

const instance = new AlgoliaInsightsService();
export default instance;
